// App.js - Composant principal
import React, { useState, useEffect } from 'react';




import ActiclesTable from '../Dashboard/ActiclesTable';
import NavbarADM from '../components/Navbar/NavbarADM';
import SidebarADM from '../components/Sidebar/SidebarADM';

function ArcticlesPageADM({tel}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Détection de la taille d'écran pour le mode mobile
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="app">
      <SidebarADM 
        isOpen={sidebarOpen} 
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />
      <div className="main-content">
        <NavbarADM
        tel={tel}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
        />
        <div className="mt-5" style={{marginTop:'70px'}}>
           <ActiclesTable />
         </div>
       
  
      </div>
    </div>
  );
}

export default ArcticlesPageADM;






